/*****************************************************************************************************************************************************
 * messages by count monitoring *
 ****************************************************************************************************************************************************/
define('commons/monitoring/messages-by-count-monitoring',['jquery', 'commons/monitoring/base-monitoring'], function($, BaseMonitoring) {

    var MessagesByCountMonitoring = function() {
        // Call parent init method
        BaseMonitoring.apply(this, arguments);
    };

    // Inherit from MessageMonitoring
    for ( var element in BaseMonitoring.prototype) {
        MessagesByCountMonitoring.prototype[element] = BaseMonitoring.prototype[element];
    }

    MessagesByCountMonitoring.prototype.processResponse = function(response) {
        response.reverse();
        var data = [];
        var labels = ["Time"].concat(this.mapping.labels);

        for (var i = 0; i < response.length; i++) {
            var d = response[i];
            var date = new Date();
            date.setTime(d.time);
            var tmp = [];
            for (var k = 0; k < this.mapping.keys.length; k++) {
                tmp.push(d[this.mapping.keys[k]]);
            }
            data.push([date].concat(tmp));
        }

        return {
            data: data,
            labels: labels
        };
    };

    return MessagesByCountMonitoring;
});
